/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Remove all non-digit characters
    let digits = value.replace(/\D/g, '');

    // Remove country code or leading 0 if present
    if (digits.startsWith('44')) {
        digits = digits.slice(2);
    } else if (digits.startsWith('0')) {
        digits = digits.slice(1);
    }

    // Limit to 10 digits (after stripping leading '0' or '44')
    digits = digits.slice(0, 11);

    // Format only when there's input
    if (digits.length === 0) return '';

    if (digits.length < 5) {
        return `+44 ${digits}`;
    }

    return `+44 ${digits.slice(0, 4)} ${digits.slice(4)}`;
};
